import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const List = styled.div`
  display: flex;
  flex-direction: row;
  display: flex;
  flex-direction: row;
  align-items: center;

  justify-content: center;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
    gap: 4px;
  }
`
export const TitleWrapper = styled.div`
  margin-bottom: 24px;
`
